/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Downgrade_Description_No_DateInputs */



/**
* | output |
* | --- |
* | "Changes take effect at the end of your billing period. You keep Team features until then." |
*
* @param {Sub_Downgrade_Description_No_DateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_downgrade_description_no_date = /** @type {((inputs?: Sub_Downgrade_Description_No_DateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Downgrade_Description_No_DateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Änderungen treten am Ende Ihres Abrechnungszeitraums in Kraft. Sie behalten Team-Funktionen bis dahin.")
	return /** @type {LocalizedString} */ ("Changes take effect at the end of your billing period. You keep Team features until then.")
});